var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLowerF(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 63,
    viewBox: "0 0 35 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.69 12.6163L31.3 13.2563C30.47 8.90629 29.38 5.19629 25.99 3.84629C24.01 3.01629 21.83 3.20629 20.04 4.29629C18.38 5.38629 17.03 7.17629 16.14 9.60629C15.44 11.9763 14.99 14.8563 14.99 17.9263V29.2563H28.88V32.6463H14.98V62.2763H11.59V32.6463H0V29.2563H11.59V17.9263C11.59 14.5363 12.04 11.2663 12.93 8.58629C13.95 5.38629 15.94 2.76629 18.31 1.35629C20.93 -0.183706 24.45 -0.433706 27.33 0.716294C32.13 2.69629 33.79 7.88629 34.69 12.6163Z",
    fill: "#949494"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLowerF);
export default __webpack_public_path__ + "static/media/LOWER_F.aeded8aa9ca711ea2a8ac65a10e87d21.svg";
export { ForwardRef as ReactComponent };